module.exports = __webpack_public_path__ + "img/86.05c35ddc.jpg";